import { render, staticRenderFns } from "./OrderRoundOrders.vue?vue&type=template&id=73e48465&"
import script from "./OrderRoundOrders.vue?vue&type=script&lang=js&"
export * from "./OrderRoundOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports